import axiosInstance from '@/axiosInstance'

export default {
  namespaced: true,
  state: () => ({
    clients: JSON.parse(sessionStorage.getItem('clients') || '[]'),
    isFetched: sessionStorage.getItem('clientsFetched') === 'true'
  }),
  mutations: {
    setClients(state, clients) {
      state.clients = clients
      state.isFetched = true
      // Cache to sessionStorage
      sessionStorage.setItem('clients', JSON.stringify(clients))
      sessionStorage.setItem('clientsFetched', 'true')
    },
    clearClients(state) {
      state.clients = []
      state.isFetched = false
      sessionStorage.removeItem('clients')
      sessionStorage.removeItem('clientsFetched')
    }
  },
  actions: {
    async fetchClients({ commit, state }) {
      if (state.isFetched) return
      try {
        const response = await axiosInstance.get('client-profiles/')
        commit('setClients', response.data)
      } catch (error) {
        console.error('Error fetching project:', error)
      }
    },
    async refetchClients({ commit, dispatch }) {
      commit('clearClients')
      await dispatch('fetchClients')
    }
  },
  getters: {
    clients: state => state.clients,
    isFetched: state => state.isFetched
  }
}